import LatestNews from './LatestNews';

const VisionMission = () => {
  
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb "> 
      <div className="col-md-12 row">
        
      <div className="row justify-content-center mt-3 pb-4">
          <div className="col-md-8 text-center heading-section ftco-animate">
            <h2 className="mb-4 text-success">
              <span className="text-warning">Vision &amp;  </span> Mission
            </h2>
          </div>
        </div>

      <div className="col-md-8">

      <div className="container">


        <div className="row">
          <div className=" col-md-12 order-md-first">
            <div className="text px-4">
              <h2 className="mb-4 text-primary"> Vision </h2>
              <p>
              To be an established institution in teacher education through the
inculcation of values ​​and the integration of educational technology, developing competent
teachers committed to educational excellence.
              </p>
            </div>
          </div>
      </div>

      <div className="row">
          <div className=" col-md-12 order-md-first">
            <div className="text px-4">
              <h2 className="mb-4 text-primary"> Mission </h2>
              <p>
              To provide quality teacher education through a structured curriculum that promotes
professional competence and academic rigor.</p>
<p>To inculcate moral, social, and professional values ​​among student teachers to enable
responsible and ethical teaching practices.</p>
<p>To integrate appropriate educational technology in teaching learning processes to enhance
instructional effectiveness.</p>
<p>To equip student teachers with pedagogical skills and practical experience required for
effective classroom instruction.</p>
<p>To encourage reflective practice and continuous professional development among prospective
teachers.
              </p>
          
            </div>
          </div>
        </div>  
      
        
        </div>

      </div>
        <div className="col-md-4">
            <LatestNews />
          </div>
      </div>
      <hr className="custom-hr"/>
    </section>

  );
};

export default VisionMission;
